/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CandidateCompany,
    CandidateCompanyFromJSON,
    CandidateCompanyFromJSONTyped,
    CandidateCompanyToJSON,
} from './';

/**
 * Item ligero de oferta para listados vista candidato [P_A_02] [P_A_11]
 * @export
 * @interface CandidatePublicOfferItem
 */
export interface CandidatePublicOfferItem {
    /**
     * 
     * @type {number}
     * @memberof CandidatePublicOfferItem
     */
    id?: number;
    /**
     * true: viene el company, false: viene el company_name
     * @type {boolean}
     * @memberof CandidatePublicOfferItem
     */
    displayCompanyName?: boolean;
    /**
     * 
     * @type {CandidateCompany}
     * @memberof CandidatePublicOfferItem
     */
    company?: CandidateCompany;
    /**
     * 
     * @type {string}
     * @memberof CandidatePublicOfferItem
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidatePublicOfferItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidatePublicOfferItem
     */
    text?: string;
    /**
     * normal, fct, dual
     * @type {string}
     * @memberof CandidatePublicOfferItem
     */
    modality?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidatePublicOfferItem
     */
    date?: string;
    /**
     * id tipo de contrato
     * @type {number}
     * @memberof CandidatePublicOfferItem
     */
    contractType?: number;
    /**
     * duración del trabajo
     * @type {string}
     * @memberof CandidatePublicOfferItem
     */
    length?: string;
    /**
     * bruto año, neto al mes, ...
     * @type {string}
     * @memberof CandidatePublicOfferItem
     */
    salaryType?: string;
    /**
     * 
     * @type {number}
     * @memberof CandidatePublicOfferItem
     */
    salaryMin?: number;
    /**
     * 
     * @type {number}
     * @memberof CandidatePublicOfferItem
     */
    salaryMax?: number;
    /**
     * Estado actual de la candidatura, si no esta inscrito viene null
     * @type {string}
     * @memberof CandidatePublicOfferItem
     */
    status?: string;
    /**
     * tipo de horario
     * @type {number}
     * @memberof CandidatePublicOfferItem
     */
    schedule?: number;
}

export function CandidatePublicOfferItemFromJSON(json: any): CandidatePublicOfferItem {
    return CandidatePublicOfferItemFromJSONTyped(json, false);
}

export function CandidatePublicOfferItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidatePublicOfferItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'displayCompanyName': !exists(json, 'display_company_name') ? undefined : json['display_company_name'],
        'company': !exists(json, 'company') ? undefined : CandidateCompanyFromJSON(json['company']),
        'companyName': !exists(json, 'company_name') ? undefined : json['company_name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'modality': !exists(json, 'modality') ? undefined : json['modality'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'contractType': !exists(json, 'contract_type') ? undefined : json['contract_type'],
        'length': !exists(json, 'length') ? undefined : json['length'],
        'salaryType': !exists(json, 'salary_type') ? undefined : json['salary_type'],
        'salaryMin': !exists(json, 'salary_min') ? undefined : json['salary_min'],
        'salaryMax': !exists(json, 'salary_max') ? undefined : json['salary_max'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'schedule': !exists(json, 'schedule') ? undefined : json['schedule'],
    };
}

export function CandidatePublicOfferItemToJSON(value?: CandidatePublicOfferItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'display_company_name': value.displayCompanyName,
        'company': CandidateCompanyToJSON(value.company),
        'company_name': value.companyName,
        'title': value.title,
        'text': value.text,
        'modality': value.modality,
        'date': value.date,
        'contract_type': value.contractType,
        'length': value.length,
        'salary_type': value.salaryType,
        'salary_min': value.salaryMin,
        'salary_max': value.salaryMax,
        'status': value.status,
        'schedule': value.schedule,
    };
}


